import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { REPORT_EXECUTION_TRANSLATION_PATH } from "./reportExecutionUtils";
import {
  codeSx,
  generatedInfoSx,
  headerContentSx,
  headerSx,
  logoContainerSx,
  logoSx,
  titleSx,
} from "./reportResultStyles";

interface IReportResultHeaderProps {
  title: string;
  logoSrc?: string;
  reportCode?: string | number | null;
  generatedAt: string;
  generatedBy: string;
}

const ReportResultHeader: React.FC<IReportResultHeaderProps> = ({
  title,
  logoSrc,
  reportCode,
  generatedAt,
  generatedBy,
}) => {
  const { t } = useTranslation();

  return (
    <Box component="header" sx={headerSx}>
      {logoSrc ? (
        <Box sx={logoContainerSx}>
          <Box
            alt="4uSpots logo"
            component="img"
            src={logoSrc}
            sx={logoSx}
          />
        </Box>
      ) : null}

      <Box sx={headerContentSx}>
        <Typography component="h1" fontWeight={600} sx={titleSx} variant="h5">
          {title}
        </Typography>

        {reportCode !== undefined && reportCode !== null ? (
          <Typography component="p" sx={codeSx} variant="caption">
            {t(REPORT_EXECUTION_TRANSLATION_PATH + "code")}: {reportCode}
          </Typography>
        ) : null}

        <Typography component="p" sx={generatedInfoSx} variant="caption">
          {t(REPORT_EXECUTION_TRANSLATION_PATH + "header.generatedLine", {
            date: generatedAt,
            user: generatedBy,
            interpolation: { escapeValue: false },
          })}
        </Typography>
      </Box>
    </Box>
  );
};

export default ReportResultHeader;
